import React from 'react';
import { StyleSheet, View, Text, type ViewStyle } from 'react-native';
import Ionicons from '@react-native-vector-icons/ionicons/static';
import { useTheme, GTFonts, theme } from '../../theme';
import { fs, iconSize, s, v } from '../../utils/libs';

type Props = {
  message: string;
  /** `info` = blue (default). `neutral` = grey bg + dark text. */
  tone?: 'info' | 'neutral';
  style?: ViewStyle;
};

const InfoCallout: React.FC<Props> = ({ message, tone = 'neutral', style }) => {
  const { theme } = useTheme();
  const isNeutral = tone === 'neutral';
  const backgroundColor = isNeutral
    ? theme.colors.backgroundGray100
    : theme.colors.infoLight;
  const foregroundColor = isNeutral
    ? theme.colors.text
    : theme.colors.infoDark;

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor,
        },
        style,
      ]}>
      <Ionicons
        name="information-circle-outline"
        size={iconSize(24)}
        color={foregroundColor}
      />
      <Text
        style={[
          styles.text,
          {
            color: foregroundColor,
          },
        ]}>
        {message}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: s(12) as unknown as number,
    paddingVertical: v(10),
    paddingHorizontal: s(12),
    borderRadius: theme.borderRadius.sm,
  },
  text: {
    flex: 1,
    fontSize: fs(12),
    lineHeight: fs(16),
    fontFamily: GTFonts.semibold,
  },
});

export default InfoCallout;
